import client1 from "../images/client1.png";
import client2 from "../images/client2.png";
import client3 from "../images/client3.png";

const testimonials = [
  {
    name: "Sarah Johnson",
    role: "",
    img: client1,
    text: "I lost 12 kg in just 3 months! The plan was easy to follow, and I never felt like I was starving. I finally feel confident in my own skin.",
  },
  {
    name: "Michael Chen",
    role: "",
    img: client2,
    text: "This program completely changed my lifestyle. I have more energy, my clothes fit better, and I feel healthier than ever!",
  },
  {
    name: "Lisa Rodriguez",
    role: "",
    img: client3,
    text: "The team was supportive every step of the way. I dropped two dress sizes and gained a whole new level of confidence.",
  },
];

const StarRow = () => (
  <div className="flex items-center gap-1 text-yellow-400 text-sm mt-3 font-poppins">
    {Array.from({ length: 5 }).map((_, i) => (
      <span key={i}>★</span>
    ))}
  </div>
);

const testimonial = () => {
  return (
    <section className="py-16 md:py-24 font-poppins">
      <div className="max-w-7xl mx-auto font-poppins px-4 sm:px-6 lg:px-8 overflow-x-hidden">

        <div className="text-center mb-12 md:mb-16 font-poppins">
          <h1 className="text-[32px] md:text-[36px] lg:text-[48px] font-bold text-[#2A3342] ">
            What Our Clients Say
          </h1>
          <p className="mt-4 text-[16px] text-[#556987] max-w-3xl mx-auto">
            Hear from businesses that have achieved remarkable growth with our
            SEO strategies.
          </p>
        </div>

        <div className="grid gap-6 md:gap-8 md:grid-cols-3 font-poppins">
          {testimonials.map((item) => (
            <article
              key={item.name}
              className="bg-white border border-slate-100 
              shadow-[0_4px_6px_-4px_rgba(0,0,0,0.10),0_10px_15px_-3px_rgba(0,0,0,0.10)]
              p-6 md:p-7 flex flex-col h-full"
            >

              <div className="flex items-center gap-3 font-poppins">
                <div className="h-12 w-12 rounded-full overflow-hidden shadow-md">
                  <img
                    src={item.img}
                    alt={item.name}
                    className="h-full w-full object-cover"
                  />
                </div>
                <div>
                  <h3 className="text-sm text-[18px] font-semibold text-[#2A3342] ">
                    {item.name}
                  </h3>
                  {item.role && (
                    <p className="text-xs text-[#2A3342] "> {item.role}</p>
                  )}
                </div>
              </div>

              <StarRow />

              <p className="mt-4 text-sm leading-relaxed text-[#556987]">
                <i>{item.text}</i>
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default testimonial;
